import { Component, Input, OnInit } from '@angular/core';
import { Vehicle } from '../../../shared/domain/vehicle';
import { Store } from '@ngrx/store';
import { WatchlistApplicationState } from '../../../store/watchlist-state';
import { WatchListActions } from '../../../store/actions/WatchListActions';
import { EnvironmentService } from '@nw/ui-core-shared/services';

@Component({
  selector: 'nw-dealerblock-item-v1',
  templateUrl: './dealerblock-item-v1.component.html',
  styleUrls: ['./dealerblock-item-v1.component.scss']
})
export class DealerblockItemV1Component implements OnInit {
  @Input()
  vehicle: Vehicle;
  @Input()
  saleEvents;
  timerImage;
  ifProcessingSuccessBidPlaced: boolean;

  previewTypes = {
    previewOnly: 'PREVIEW ONLY',
    competitive: 'PREVIEW WITH COMPETITIVE BIDDING',
    proxy: 'PREVIEW WITH PROXY BIDS'
  };

  constructor(
    private store: Store<WatchlistApplicationState>,
    private watchListActions: WatchListActions,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit() {
    this.timerImage = `${
      this.environmentService.getEnvironment().utilPath.asset
    }/img/timer-icon.svg`;
  }

  acceptDeclineOfferHandler$() {
    this.store.dispatch(this.watchListActions.loadWatchList());
  }

  userDeclineOfferHandler(evt) {
      this.vehicle.allowDeclineIfBid = evt;
  }

  onSuccessBidProcessing(ifProcessingSuccessBidPlaced: boolean){
    this.ifProcessingSuccessBidPlaced = ifProcessingSuccessBidPlaced;
  }

} /* istanbul ignore next */



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/components-v1/dealerblock-item-v1/dealerblock-item-v1.component.ts